import React, { useState, useEffect } from 'react';
import { message } from 'antd';
import { useParams } from 'react-router-dom';
import DefaultLayout from 'components/layout/DefaultLayout';
import { storyApi } from 'apis/story/storyApis';
import { ISupportLanguage } from 'utils/types/storyTypes';
import { useTranslation } from 'react-i18next';
import IllustUpdateWrapper from './IllustUpdateWrapper';
import { handleMessage } from 'utils/helper/message';
import { useAppDispatch } from 'hooks/redux';
import { setEditName, setStoryName } from 'store/slices/breadcumbSlice';
import { useCookies } from 'react-cookie';
import { IMinicut } from 'utils/types/resourceTypes';
import { illustApi } from 'apis/resource/illustApis';
/**
 * * 리소스 - 미니컷 수정 페이지
 */

const IllustUpdatePage = () => {
  const dispatch = useAppDispatch();
  const [cookies] = useCookies();
  const { projectId, illustId } = useParams();
  const { t } = useTranslation();

  const [data, setData] = useState<IMinicut | null>(null);
  const [supportLangList, setSupportLangList] = useState<
    ISupportLanguage[] | null
  >(null);

  const handleFetchData = async () => {
    if (projectId) {
      try {
        const storyDetailData = await storyApi.storyDetail(projectId);
        const illustRes = await illustApi.illustList(projectId.toString());
        const detailIllust = illustRes.list.find(
          (e) => e.id === Number(illustId),
        );
        const langRes = await storyApi.supportLang();
        setData(detailIllust);
        setSupportLangList(langRes);
        dispatch(setEditName(detailIllust.image_name));

        const episodeName = storyDetailData?.project?.projectDetails?.find(
          (e) => e.lang === cookies.lang,
        );
        dispatch(
          setStoryName(episodeName ? episodeName.title : storyDetailData.title),
        );
      } catch (err) {
        handleMessage(message, 'error', 'Call api error');
      }
    }
  };

  useEffect(() => {
    handleFetchData();
  }, []);

  return (
    <DefaultLayout>
      <IllustUpdateWrapper
        data={data}
        setData={setData}
        supportLangList={supportLangList}
      />
    </DefaultLayout>
  );
};

export default IllustUpdatePage;
